import { createWebHistory, createRouter } from "vue-router";
import Home from "@/components/Home.vue";
import Login from "@/components/Auth/Login.vue";
import Logout from "@/components/Auth/Logout.vue";

import MasterDataRoute from "./masterdata-route";
import TransactionRoute from "./transaction-route";
import ReportRoute from "./report-route.js"
import UploadRoute from "./upload-route.js";
import LogRoute from "./log-route.js";

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            name: "Home",
            menuTitle: "Home",
            requiresAuth: true
        }
    },
    {
        path: "/Login",
        name: "Login",
        component: Login,
        meta: {
            name: "Login",
            menuTitle: "Login",
            requiresAuth: false
        },
        props: true
    },
    {
        path: "/Logout",
        name: "Logout",
        component: Logout,
        meta: {
            name: "Logout",
            requiresAuth: false
        },
        props: true
    },
    ...MasterDataRoute,
    ...TransactionRoute,
    ...ReportRoute,
    ...UploadRoute,
    ...LogRoute
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;